import { computed, inject, Injectable, Signal } from "@angular/core";
import { Permission } from "../models/enums/permission.enum";
import { UserStore } from "../stores/user.store";

@Injectable({ providedIn: "root" })
export class PermissionService {
  private readonly userStore = inject(UserStore);

  readonly permissions: Signal<string[]> = computed(() => this.userStore.user()?.permissions ?? []);

  readonly isSuperAdmin: Signal<boolean> = computed(() => this.permissions().includes(Permission.ADMIN_ALL));

  hasPermission(permission: Permission | string): boolean {
    const list = this.permissions();
    return list.includes(Permission.ADMIN_ALL) || list.includes(permission);
  }

  hasAny(permissions: ReadonlyArray<Permission | string>): boolean {
    if (permissions.length === 0) return true;
    const list = this.permissions();
    if (list.includes(Permission.ADMIN_ALL)) return true;
    return permissions.some((p) => list.includes(p));
  }

  hasAll(permissions: ReadonlyArray<Permission | string>): boolean {
    if (permissions.length === 0) return true;
    const list = this.permissions();
    if (list.includes(Permission.ADMIN_ALL)) return true;
    return permissions.every((p) => list.includes(p));
  }
}
